import React, {useState} from 'react';
import {AutoComplete, Tag, Input} from 'antd';
import { useAxios } from '../../hooks';
import { Dinheiro } from '../';

const AutoCompleteServico = ({handleSelect}) => {
    const { getApiEmitirNotas } = useAxios();
    const [options, setOptions] = useState([]);
    

    const searchResult = async (value) => {
        /* return [{value: "asdf"},{value: "kkkk"}]; */
        var api = await getApiEmitirNotas();
        return api.get('/servicos/filtro?termo=' + value).then((result) => {
                var formatResult = result.data.map((x) => {
                    x.value = x.descricao;
                    return x;
                });
                return formatResult;
        });
        
        /* console.log("servicos",result); */
        
    }

    const handleSearch = async (value) => {
        console.log("handleSearch: ",value);
        var servicos = await searchResult(value);
       servicos = servicos.map((x) => {
            x.label = (<div className="item-wrapper">
            <span className='titulo'>
                {x.descricao.toUpperCase()}
            </span>
            <span className='preco'>
                <Tag><Dinheiro value={x.valor.replace(".",",")}></Dinheiro></Tag>

            </span>
    
    
</div>)
            return x;
        })
        setOptions(value ? servicos  : [])
    }

    return (
        <AutoComplete 
            options={options}
            onSearch={handleSearch}
            onSelect={handleSelect}
        >
            <Input.Search size="large" enterButton></Input.Search>
        </AutoComplete>
    )
}

export {AutoCompleteServico}